"use strict";
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const constants_1 = require("./constants");
const redactionKeys_1 = require("./redactionKeys");
const pino_1 = __importDefault(require("pino"));
const logLevel = (_a = process.env.LOG_LEVEL) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_LOG_LEVEL;
const censorString = (_b = process.env.LOG_CENSOR_STRING) !== null && _b !== void 0 ? _b : constants_1.DEFAULT_CENSOR_STRING;
/**
 * to specify multiple streams, use:
 * `const stream =
      typeof pino.multistream === 'function' // handle non-availability in browser
        ? pino.multistream(
            [
              {
                stream: pino.destination({ dest: '<fs-path>', append: true, sync: true }),
                level: 'trace', // log all levels in the same stream
              },
              {
                stream: process.stdout,
                level: 'trace', // log all levels in the same stream
              },
            ].filter(Boolean)
          )
        : process.stdout;`
 */
const stream = process.stdout;
exports.logger = (0, pino_1.default)({
    level: logLevel,
    timestamp: pino_1.default.stdTimeFunctions.isoTime,
    redact: {
        paths: redactionKeys_1.redactionKeys,
        censor: censorString,
    },
    formatters: {
        level: (label) => ({ level: label }),
        bindings: (_bindings) => ({}),
    },
}, stream);
